var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HappyCheckYay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HappyCheckYay",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,60 C13.4314575,60 2.22044605e-15,46.5685425 0,30 C-2.22044605e-15,13.4314575 13.4314575,4.4408921e-15 30,0 C46.5685425,-4.4408921e-15 60,13.4314575 60,30 C60,46.5685425 46.5685425,60 30,60 Z",
    id: "Available-Inline",
    stroke: "#AAD94C",
    strokeWidth: 4,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3808339,19.7569883 C41.9285037,19.3093998 41.3016282,19.0843654 40.667904,19.1420844 C40.0341797,19.1998034 39.4582736,19.534386 39.0942473,20.0563274 L25.2496226,39.8794353 L18.9174729,30.8128111 C18.5534467,30.2908698 17.9775405,29.9562872 17.3438163,29.8985682 C16.710092,29.8408492 16.0832165,30.0658836 15.6308863,30.513472 C14.8809387,31.3017295 14.8032117,32.513944 15.446346,33.3915258 L22.5869377,43.6156235 C23.1947778,44.4851477 24.1888686,45.00313 25.2497843,45.00313 C26.3106999,45.00313 27.3047907,44.4851477 27.9126308,43.6156235 L42.5655898,22.6345031 C43.208318,21.7569629 43.1305099,20.5451267 42.3808339,19.7569883 Z",
    id: "Path",
    fill: "#AAD94C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/CheckmarkCircle.bc6bb835964815dabb804117907e9dff.svg";
export { ForwardRef as ReactComponent };